import { LauncherPosition } from "./store/definitions";

/*
 * Posição do launcher/janela aplicada como CSS variables no :root (NÃO inline no elemento) —
 * assim o @media do mobile em webchat-position.css consegue sobrescrever as vars no escopo do
 * elemento quando sameOnMobile=false. Ausente = os fallbacks do CSS (bottom-right / 20 / 19).
 * MVP: cantos inferiores (bottom-right / bottom-left).
 */
export const DEFAULT_LAUNCHER_POSITION: LauncherPosition = {
    corner: "bottom-right",
    offsetX: 20,
    offsetY: 19,
    sameOnMobile: true
};

export const applyLauncherPosition = (
    position: LauncherPosition,
    root: HTMLElement = document.documentElement
): void => {
    const offsetX = `${position.offsetX}px`;
    const offsetY = `${position.offsetY}px`;
    const isLeft = position.corner === "bottom-left";

    root.style.setProperty("--wc-bottom", offsetY);
    root.style.setProperty("--wc-left", isLeft ? offsetX : "auto");
    root.style.setProperty("--wc-right", isLeft ? "auto" : offsetX);
    root.style.setProperty("--wc-align", isLeft ? "flex-start" : "flex-end");
};
